/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { storeSettingGet } from '../fn/store-settings/store-setting-get';
import { StoreSettingGet$Params } from '../fn/store-settings/store-setting-get';
import { storeSettingPut } from '../fn/store-settings/store-setting-put';
import { StoreSettingPut$Params } from '../fn/store-settings/store-setting-put';
import { StoreSettingResponse } from '../models/store-setting-response';

@Injectable({ providedIn: 'root' })
export class StoreSettingsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `storeSettingGet()` */
  static readonly StoreSettingGetPath = '/stores/{storeId}/settings/{id}';

  /**
   * Get a store setting. Settings available: OM_INJECTION.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storeSettingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  storeSettingGet$Response(params: StoreSettingGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreSettingResponse>> {
    return storeSettingGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a store setting. Settings available: OM_INJECTION.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storeSettingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storeSettingGet(params: StoreSettingGet$Params, context?: HttpContext): Observable<StoreSettingResponse> {
    return this.storeSettingGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StoreSettingResponse>): StoreSettingResponse => r.body)
    );
  }

  /** Path part for operation `storeSettingPut()` */
  static readonly StoreSettingPutPath = '/stores/{storeId}/settings/{id}';

  /**
   * Upsert a store setting. Settings available: OM_INJECTION.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storeSettingPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storeSettingPut$Response(params: StoreSettingPut$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreSettingResponse>> {
    return storeSettingPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Upsert a store setting. Settings available: OM_INJECTION.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storeSettingPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storeSettingPut(params: StoreSettingPut$Params, context?: HttpContext): Observable<StoreSettingResponse> {
    return this.storeSettingPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<StoreSettingResponse>): StoreSettingResponse => r.body)
    );
  }

}
